import { useContext, useEffect, useState } from "react";

import OnboardingBoilerplate from "./OnboardingBoilerplate";
import styled from "styled-components";
import ImagePicker from "../../../editors/ImagePicker";
import { serverLine } from "../../../../controllers/network/serverLine";
import Context from "../../../../Context";
import { useTranslation } from "react-i18next";

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

const Text = styled.div`
  font-size: 15px;
  opacity: 0.7;
`;
export default function AskDocumentVerification({ asEditPage }) {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const [value, setValue] = useState({ type: "DEFAULT", data: null });
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (loggedInUser) {
      if (loggedInUser.documentVerification)
        setValue(loggedInUser.documentVerification);
    }
  }, []);

  return (
    <OnboardingBoilerplate
      asEditPage={asEditPage}
      editPageTitle="Document Verification"
      title={"NGO document verification"}
      desc={"Please! upload certificate that proves the validity of your NGO"}
      onSubmit={onSubmit}
      loading={loading}
      skipID={"documentVerificationOnboardingSkipped"}
    >
      <UploadSection>
        <ImagePicker
          forPerson={true}
          value={value}
          onChange={setValue}
        ></ImagePicker>
      </UploadSection>
    </OnboardingBoilerplate>
  );

  async function onSubmit() {
    setLoading(true);

    try {
      await serverLine.patch("/me", {
        changes: {
          documentVerification: value,
        },
      });
      setLoading(false);

      let newLoggedInUser = {
        ...loggedInUser,
        documentVerification: value,
      };
      setLoggedInUser(newLoggedInUser);

      window.popupAlert(t("saved"));
    } catch (e) {
      window.popupAlert(e.message);
      setLoading(false);
    }
  }
}
